<h3 class="text-center">{{'status.status'| translate}}</h3>
<ngb-progressbar class="my-3" [value]="progress" [max]="max" [striped]="true" [animated]="true" type="success" [showValue]="true">
</ngb-progressbar>